// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n8Mh","content":"styles_content__3EA5U","tableWrap":"styles_tableWrap__3JRzm"};